module.exports = __webpack_public_path__ + "img/SHRCCNSHXXX.92cd4607.png";